// @ts-nocheck
import toolkitConstants from "@toolkit/constants";
import overrideProps from "@toolkit/Framework/Common/Utilities/overrideProps";

export default overrideProps(toolkitConstants, {
    formField: {
        borderWidth: 2,
    },
    /* Store Custom Code - Start */
    widgetGroup: {
        storeLists: "Store Lists" as any,
        storeListDetails: "Store List Details" as any,
    },
    /* Store Custom Code - End */
});
